<template>
  <div class="note">
    <button @click="goBack">
      Go Back
    </button>
    <div v-if="camshow" id="cam">
      <camNote ref="camnote" />
    </div>
  </div>
</template>

<script>
import router from '@/router.js';
import { mapActions,mapGetters } from 'vuex'; // mapState,
import store from "@/store";
import firebase from '@/firebase/firestore';

import camNote from '@/components/noteCam.vue';

export default {
  name: 'Note',
  components: {
    camNote,
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters(['camshow', 'txtshow', 'micshow', 'drawshow']),
  },
  methods: {
    ...mapActions(['fetchCamShow','fetchTxtShow','fetchMicShow','fetchDrawShow']),
    goBack() {
      router.push({ name: 'home', params: { userId: firebase.auth().currentUser.uid } });
      store.commit('setCamShow', false);
      store.commit('setTxtShow', false);
      store.commit('setMicShow', false);
      store.commit('setDrawShow', false);
      this.$refs.camnote.stopCam();
      // this.fetchCamShow();
      // this.fetchTxtShow();
      // this.fetchMicShow();
      // this.fetchDrawShow();
    },
  },
};
</script>

<style>
@media screen and (max-width:768px){
  /*画面サイズが480pxからはここを読み込む*/
}

@media screen and (min-width:768px) and ( max-width:1024px) {
  /*画面サイズが768pxから1024pxまではここを読み込む*/
}

@media screen and (min-width:1024px) {
  /*画面サイズが1024pxからはここを読み込む*/
}

.note{
  text-align: center;
}
#cam{
  margin: 0 auto;
}
</style>
